import services from '@/services';
const TOPICS_PATH = 'topics';
const ITEMS_PATH = 'items';
export default {
    async getItem(topic_uid, item_uid) {
        return await services.getAsync({
            url: `/${TOPICS_PATH}/${topic_uid}/${ITEMS_PATH}/${item_uid}`,
            hasToken: true
        });
    },
    async getSubtopic(id) {
        return await services.getAsync({
            url: `/${TOPICS_PATH}/subtopics/${id}/items`,
            hasToken: true
        });
    },

    getSigns: async () => {
        return await services.getAsync({
            url: `/${TOPICS_PATH}/ddx/signs`,
            timeout: 10000,
            hasToken: true
        });
    },

    postSigns: async ({ signs, species, sex }) => {
        return await services.postAsync({
            url: `/${TOPICS_PATH}/ddx/signs`,
            body: { signs, species, sex },
            timeout: 10000,
            hasToken: true
        });
    },

    getDiagnosis: async (id) => {
        return await services.getAsync({
            url: `/${TOPICS_PATH}/ddx/diagnoses/${id}`,
            timeout: 10000,
            hasToken: true
        });
    }
}